const ML_PER_TBSP = 14.787;
const TBSP_PER_CUP = 16;
const fractions: [number, string][] = [
	[0.25, "¼"],
	[0.333, "⅓"],
	[0.5, "½"],
	[0.666, "⅔"],
	[0.75, "¾"],
];

/**
 * Displays ml as a combination of cups and tbsp
 *
 * @param ml The number of millilitres
 * @returns The formatted string
 */
export function formatCupsAndTbsp(ml: number): string {
	const tbsp = Math.round(ml / ML_PER_TBSP);
	const cups = tbsp / TBSP_PER_CUP;
	const wholeCups = Math.floor(cups);
	let remainingTbsp = tbsp - wholeCups * TBSP_PER_CUP;
	const remainingTbspFraction = remainingTbsp / TBSP_PER_CUP;

	let partialCups = "";
	for (let i = fractions.length - 1; i >= 0; i--) {
		if (remainingTbspFraction > fractions[i][0]) {
			partialCups = fractions[i][1];
			remainingTbsp -= Math.round(TBSP_PER_CUP * fractions[i][0]);
			break;
		}
	}
	let formatted = handlePlural(
		"cup",
		wholeCups + (partialCups ? 1 : 0), // Adding 1 to guarantee it is plural for cases like 1 1/2 cups, instead of 1 1/2 cup.
		(wholeCups || "") + partialCups, // We don't what the zero to show in front of partial cups.
	);
	if (formatted && remainingTbsp > 0) {
		formatted += " and ";
	}
	formatted += handlePlural("tbsp", remainingTbsp, remainingTbsp);
	return formatted;
}

/**
 * Handles the formatting for zeros and plurals
 *
 * @param singular The string of the singular form. ex. "cup"
 * @param count The actual count
 * @param displayValue The unit count to display. Could be the same as count, or
 *   a fractional number
 * @returns The formatted string
 */
function handlePlural(
	singular: string,
	count: number,
	displayValue: number | string,
): string {
	if (count === 0) return "";
	if (count === 1 || (count > 0 && count < 1)) {
		return `${displayValue} ${singular}`;
	}
	return `${displayValue} ${singular}s`;
}
